
import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const BeginnerHero = () => {
  return (
    <section className="relative bg-gradient-to-r from-piano-black to-gray-900 text-white py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-8">
          <div>
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-6">
              Klaverundervisning for begyndere
            </h1>
            <p className="text-xl text-gray-300 mb-6">
              Har du altid drømt om at spille klaver? Uanset alder eller musikalsk baggrund hjælper jeg dig med at tage de første skridt på din musikalske rejse med skræddersyet undervisning for begyndere.
            </p>
            <div className="space-y-4">
              <div className="flex items-center">
                <span className="bg-piano-gold rounded-full w-8 h-8 flex items-center justify-center mr-3 text-black font-bold">1</span>
                <p>Personlig undervisning tilpasset dit niveau</p>
              </div>
              <div className="flex items-center">
                <span className="bg-piano-gold rounded-full w-8 h-8 flex items-center justify-center mr-3 text-black font-bold">2</span>
                <p>Lær grundlæggende teknikker og nodelæsning</p>
              </div>
              <div className="flex items-center">
                <span className="bg-piano-gold rounded-full w-8 h-8 flex items-center justify-center mr-3 text-black font-bold">3</span>
                <p>Spil dine favoritsange hurtigere end du tror</p>
              </div>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-piano-gold hover:bg-piano-gold/90 text-black font-semibold">
                <Link to="/kontakt#top">Book gratis prøvetime</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-white text-black hover:bg-white/10">
                <Link to="/undervisning#top" className="flex items-center">
                  Se alle muligheder <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
          <div className="relative">
            <div className="bg-piano-gold/10 rounded-lg p-2 md:p-4">
              <img 
                src="/lovable-uploads/69c22a01-1204-49e5-9098-5b2d417301e8.png" 
                alt="Oscar Gilbert - Klaverlærer for begyndere" 
                className="rounded-lg object-cover max-h-96 w-full object-[50%_25%]"
                loading="eager"
                width={800}
                height={600}
              />
            </div>
            <div className="absolute -bottom-5 -right-5 bg-white text-black p-4 rounded-lg shadow-lg max-w-xs hidden md:block">
              <p className="font-semibold text-sm">
                "Min filosofi er at alle kan lære at spille klaver med den rette vejledning og undervisningsmetode."
              </p>
              <p className="text-sm mt-2 text-gray-600">- Oscar Gilbert, Pianist</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeginnerHero;
